import { createIcon } from '@chakra-ui/icons';

const QuestionIconNew = createIcon({
  displayName: 'QuestionIcon',
  viewBox: '0 0 16 16',
  path: (
    <>
      <path d="M13.3333 1.33325H2.66659C1.93125 1.33325 1.33325 1.93125 1.33325 2.66659V10.6666C1.33325 11.4019 1.93125 11.9999 2.66659 11.9999H4.66659V14.5106L8.85125 11.9999H13.3333C14.0686 11.9999 14.6666 11.4019 14.6666 10.6666V2.66659C14.6666 1.93125 14.0686 1.33325 13.3333 1.33325ZM13.3333 10.6666H8.48192L5.99992 12.1559V10.6666H2.66659V2.66659H13.3333V10.6666Z" fill="currentColor" />
      <path d="M10.0001 7.99992C10.7365 7.99992 11.3334 7.40296 11.3334 6.66659C11.3334 5.93021 10.7365 5.33325 10.0001 5.33325C9.2637 5.33325 8.66675 5.93021 8.66675 6.66659C8.66675 7.40296 9.2637 7.99992 10.0001 7.99992Z" fill="currentColor" />
      <path d="M6.00008 7.99992C6.73646 7.99992 7.33342 7.40296 7.33342 6.66659C7.33342 5.93021 6.73646 5.33325 6.00008 5.33325C5.2637 5.33325 4.66675 5.93021 4.66675 6.66659C4.66675 7.40296 5.2637 7.99992 6.00008 7.99992Z" fill="currentColor" />
    </>
  ),
});

export default QuestionIconNew;
